// index.js
import axios from 'axios';
import { marked } from 'marked';
import CryptoJS from 'crypto-js';
const secretKey = 'yuzhouwudidiaozhatian'; // 替换为您自己的密钥

// 加密
function encryptData(data) {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return encryptedData;
}
// 解密
function decryptData(encryptedData) {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
}
// ip登录
function IpLogin(baseUrl) {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl+'iplogin/').then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
//机构账号登录
function OrgLogin(baseUrl,data) {
    var  formData = new FormData(); 
    formData.append("username", data.username);
    formData.append("password", data.password);
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'login/',
            method: 'post',
            data: formData,
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
//个人账号登录
function PersonLogin(baseUrl,data) {
    var  formData = new FormData(); 
    formData.append("username", data.username);
    formData.append("password", data.password);
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'personlogin/',
            method: 'post',
            data: formData,
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
//获取权限
function GetRole(baseUrl,data) {
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'auth/token/getrole',
            method: 'get',
            headers:{
                token:data
            }
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
// 忘记密码
function ForgetPassword(baseUrl,data) {
    var  formData = new FormData(); 
    formData.append("email", data.email);
    formData.append("code", data.code);
    formData.append("password", data.password);
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'forgetpassword/',
            method: 'post',
            data: formData,
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
//找回密码发送邮箱验证码
function SendEmailCode(baseUrl,data) {
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'forgetpassword/',
            method: 'get',
            params: {
                email: data.email
            }
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
// 获取导航列表
function getNavListApi(baseUrl,data,token) {
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'organ/products/',
            method: 'get',
            headers:{
                token:token
            },
            params: data
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
// 注册接口
function Register(baseUrl,data) {
    var formData = new FormData();
    for(var key in data){
        formData.append(key, data[key]);
    }
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'register/',
            method: 'post',
            data: formData
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}

// 短信验证码
function SendSmsCode(baseUrl,data) {
    var formData = new FormData();
    for(var key in data){
        formData.append(key, data[key]);
    }
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl+'sendmsg/',
            method: 'post',
            data: formData
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}
// markdown转html
function markdownToHtml(markdown) {
    marked.setOptions({
        renderer: new marked.Renderer(),
        pedantic: false,
        gfm: true,
        breaks: false,
    });
    return marked(markdown);
}

// 邮箱正则
function isEmail(s) {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}
// 手机号正则
function isPhone(s) {
    return /^1[0-9]{10}$/.test(s)
}
// 是否URL地址
function isURL(s) {
    return /^http[s]?:\/\/.*/.test(s)
}
export default {
    IpLogin,
    OrgLogin,
    PersonLogin,
    GetRole,
    ForgetPassword,
    SendEmailCode,
    getNavListApi,
    Register,
    SendSmsCode,
    markdownToHtml,
    isEmail,
    isPhone,
    isURL,
    encryptData,
    decryptData
}